import { useEffect, useState } from 'react';
import type { Papel } from './api.ts';

/**
 * Quem está usando o Hub, para a tela saber o que mostrar.
 *
 * ⚠️ **Isto esconde botão. Não é segurança.** A garantia mora no servidor
 * (`api/src/plugins/autenticacao.ts`): mesmo que alguém force esta variável no
 * console do navegador, o `PATCH` e o `DELETE` voltam 403. Esconder sem recusar
 * é decoração; recusar sem esconder é uma tela cheia de botões que dão erro.
 * O Hub faz os dois, e o servidor é o que vale.
 *
 * Mesmo desenho de `sigilo.ts` e `tema.ts`: uma variável de módulo e quem quiser
 * ser avisado se inscreve. Não precisa de contexto do React — o papel muda duas
 * vezes na vida da aba: quando entra e quando sai.
 */
const ouvintes = new Set<(papel: Papel | null) => void>();

let papelAtual: Papel | null = null;

export function definirPapel(papel: Papel | null): void {
  papelAtual = papel;
  ouvintes.forEach((o) => o(papelAtual));
}

export function usarPapel(): Papel | null {
  const [atual, setAtual] = useState(papelAtual);
  useEffect(() => {
    const aoMudar = (novo: Papel | null) => setAtual(novo);
    ouvintes.add(aoMudar);
    return () => {
      ouvintes.delete(aoMudar);
    };
  }, []);
  return atual;
}

/**
 * Atalho para o que a tela pergunta o tempo todo.
 *
 * Fecha na dúvida: sem papel definido, não é master. Uma tela que aparece
 * completa por um instante antes de o papel chegar já mostrou o que não devia.
 */
export function usarEhMaster(): boolean {
  return usarPapel() === 'master';
}
